import { TaxRate } from '@mews-commander/types';
import { CoproductElement, Identifiable } from '@mews/std';
import { Amount } from '@mews-commander/data-access';

export type FieldConstraint = Record<string, unknown>;

export enum BasePriceFormTab {
    BasePrice = 'BasePrice',
    Adjustments = 'Adjustments',
    AgeCategories = 'AgeCategories',
}

export enum AttributeType {
    AgeCategory = 'AgeCategory',
    ResourceCategory = 'ResourceCategory',
}

export interface PricingScreenProps {
    productId: string;
    rateId: string;
    serviceId: string;
}

export interface Price {
    value: number;
    isOverriden: boolean;
}

export interface BasePrice {
    value: Amount;
    prices: Array<Price>;
}

export interface Occupancy {
    available: number;
    reserved: number;
    value: number;
}

export interface ResourceCategoryOccupancy {
    resourceCategoryId: string;
    occupancies: Array<Occupancy>;
}
export interface ResourceCategoryTypeOccupancy {
    categoryOccupancies: Array<ResourceCategoryOccupancy>;
    occupancies: Array<Occupancy>;
    resourceCategoryType: string;
}

export interface AttributePrice {
    id: string;
    baseId: string | null;
    relativeAdjustment: number;
    absoluteAdjustment: number;
    prices: Array<Price>;
}

export interface BasePricing {
    baseId: string | null;
    subAttributePricings: unknown[];
    id: string;
}

export interface BodyPricing extends BasePricing {
    prices: Array<Price>;
}

export interface AsidePricing extends BasePricing {
    relativeAdjustment: number;
    absoluteAdjustment: number;
}

interface AgeCategoryAdjustment extends Identifiable {
    value: number;
}
export interface CapacityOffsetAdjustments {
    negativeOccupancyAdjustment: number;
    extraOccupancyAdjustment: number;
    ageCategoryAdjustments: Array<AgeCategoryAdjustment>;
}

export enum RateAdjustmentType {
    BaseRateAdjustment = 'BaseRateAdjustment',
    DependentRateAdjustment = 'DependentRateAdjustment',
}

type BaseRateAdjustment = CoproductElement<
    RateAdjustmentType.BaseRateAdjustment,
    { currencyCode: string; value: number; taxRates: Array<TaxRate> }
>;

type DependentRateAdjustment = CoproductElement<
    RateAdjustmentType.DependentRateAdjustment,
    { baseRateId: string; absoluteAdjustment: number; relativeAdjustment: number }
>;

export type RateAdjustment = BaseRateAdjustment | DependentRateAdjustment;

type AgeCategoryId = string;
export enum AgeCategoryAdjustmentType {
    StandardCapacityAdjustment = 'StandardCapacityAdjustment',
    ExtraCapacityAdjustment = 'ExtraCapacityAdjustment',
}
export type AgeCategoryAdjustmentsFormValues = Record<AgeCategoryId, Record<AgeCategoryAdjustmentType, string>>;

export interface OccupancyAdjustmentFormValues {
    extraOccupancyAdjustment: string;
    negativeOccupancyAdjustment: string;
}

export enum SeasonalRoomAdjustmentFormTabs {
    TimePeriod = 'TimePeriod',
    BasePrice = 'BasePrice',
    Adjustments = 'Adjustments',
}
